import styled from 'styled-components';
import React from 'react';
import { EventType, MessageType, } from '../graphql/graphql';
import { MessageStatus } from '../components/Message/MessageStatus';
import { MessageRow } from '../components/Message/MessageRow';
import { QuestionOptions } from './QuestionOptions';
import { CommandOptions } from './CommandOptions';
const MessageContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 1.25rem;
`;
export const isMessageEvent = (event) => {
    return event.type === EventType.Message && event.messageEvent !== null;
};
export const ChatBoxMessage = ({ event, isNotLastOption, onOptionClick, onCommandClick, onAttachmentClick, isLastMessageCloseEvent, }) => {
    var _a, _b;
    return (React.createElement(MessageContainer, { "data-testid": "event-row-container" },
        React.createElement(MessageRow, { event: event, onAttachmentClick: onAttachmentClick }),
        React.createElement(MessageStatus, { event: event }),
        ((_a = event.messageEvent) === null || _a === void 0 ? void 0 : _a.messageType) === MessageType.Question && (React.createElement(QuestionOptions, { options: event.messageEvent.question.options, onOptionClick: onOptionClick, isNotLastOption: isNotLastOption, isLastMessageCloseEvent: isLastMessageCloseEvent })),
        ((_b = event.messageEvent) === null || _b === void 0 ? void 0 : _b.messageType) === MessageType.Command && (React.createElement(CommandOptions, { items: event.messageEvent.command.items, onItemClick: onCommandClick, isNotLastOption: isNotLastOption }))));
};
//# sourceMappingURL=ChatBoxMessage.js.map